var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeIl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1100,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1100v800H0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 75h1100v125H0ZM0 600h1100v125H0Z",
    fill: "#0038b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.816 472.853h252.368L550 254.295ZM550 545.705l126.184-218.558H423.816Z",
    fill: "none",
    stroke: "#0038b8",
    strokeWidth: 27.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeIl);
export default __webpack_public_path__ + "static/media/he-IL.02666981937d8e725c680936f04051d7.svg";
export { ForwardRef as ReactComponent };